<template>
  <el-dialog
    title="录入线下协议/保单"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-form
      ref="agreementForm"
      :model="form"
      :rules="rules"
      label-width="120px"
      v-loading="loading"
    >
      <el-form-item label="生效时间：" prop="effectiveTime">
        <el-date-picker
          v-model="form.effectiveTime"
          type="date"
          placeholder="请选择生效时间"
          value-format="timestamp"
          style="width: 100%">
        </el-date-picker>
      </el-form-item>
      
      <el-form-item label="失效时间：" prop="expireTime">
        <el-date-picker
          v-model="form.expireTime"
          type="date"
          placeholder="请选择失效时间"
          value-format="timestamp"
          style="width: 100%">
        </el-date-picker>
      </el-form-item>
      
      <el-form-item label="大保单号：" prop="policyNo">
        <el-input
          v-model="form.policyNo"
          placeholder="请输入大保单号"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="协议文件：" prop="agreementFile">
        <div v-if="!form.agreementUrl">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="(response, file, fileList) => handleUploadSuccess(response, file, fileList, 'agreement')"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept=".pdf,.jpg,.png,.jpeg"
            name="fileVal"
          >
            <el-button size="small" type="primary">上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过5MB</div>
          </el-upload>
        </div>
        <div v-else>
          <el-button size="small" @click="viewFile(form.agreementUrl)">查看</el-button>
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="(response, file, fileList) => handleUploadSuccess(response, file, fileList, 'agreement')"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept=".pdf,.jpg,.png,.jpeg"
            name="fileVal"
            style="margin-left: 10px;"
          >
            <el-button size="small" type="primary">重新上传</el-button>
          </el-upload>
        </div>
      </el-form-item>
      
      <el-form-item label="电子保单：" prop="policyFile">
        <div v-if="!form.policyUrl">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="(response, file, fileList) => handleUploadSuccess(response, file, fileList, 'policy')"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept=".pdf,.jpg,.png,.jpeg"
            name="fileVal"
          >
            <el-button size="small" type="primary">上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过5MB</div>
          </el-upload>
        </div>
        <div v-else>
          <el-button size="small" @click="viewFile(form.policyUrl)">查看</el-button>
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="(response, file, fileList) => handleUploadSuccess(response, file, fileList, 'policy')"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept=".pdf,.jpg,.png,.jpeg"
            name="fileVal"
            style="margin-left: 10px;"
          >
            <el-button size="small" type="primary">重新上传</el-button>
          </el-upload>
        </div>
      </el-form-item>
      
      <el-form-item label="备注：" prop="note">
        <el-input
          v-model="form.note"
          type="textarea"
          placeholder="请输入备注信息"
          :rows="3"
        ></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveHyxUserPolicy, getHyxUserInfo } from '@/api/member'

export default {
  name: 'Agreement',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      submitting: false,
      form: {
        effectiveTime: '',
        expireTime: '',
        policyNo: '',
        agreementUrl: '',
        policyUrl: '',
        note: ''
      },
      rules: {
        effectiveTime: [
          { required: true, message: '请选择生效时间', trigger: 'change' }
        ],
        expireTime: [
          { required: true, message: '请选择失效时间', trigger: 'change' }
        ],
        policyNo: [
          { required: true, message: '请输入大保单号', trigger: 'blur' }
        ],
        note: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      },
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + (localStorage.getItem('jubao_admin_token') || localStorage.getItem('jubao_admin') || '')
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    // 初始化数据
    async initData() {
      this.loading = true
      try {
        // 获取用户信息，包括已有的协议和保单信息
        const res = await getHyxUserInfo({ id: this.userId })
        if (res.err_code === 0) {
          const data = res.data
          this.form.policyNo = data.general_policy_no || ''
          this.form.note = data.note || ''
          this.form.agreementUrl = data.agreement_url || ''
          this.form.policyUrl = data.general_policy_url || ''
          
          // 设置时间
          if (data.general_policy_effected_at && data.general_policy_effected_at !== '0001-01-01T00:00:00Z') {
            this.form.effectiveTime = new Date(data.general_policy_effected_at).getTime()
          }
          if (data.general_policy_expired_at && data.general_policy_expired_at !== '0001-01-01T00:00:00Z') {
            this.form.expireTime = new Date(data.general_policy_expired_at).getTime()
          }
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        this.$message.error('获取用户信息失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },
    // 上传成功回调
    handleUploadSuccess(response, file, fileList, type) {
      if (response && response.err_code === 0) {
        if (type === 'agreement') {
          this.form.agreementUrl = response.data
        } else if (type === 'policy') {
          this.form.policyUrl = response.data
        }
        this.$message.success('上传成功')
      } else {
        this.$message.error('上传失败: ' + (response ? response.err_msg : '未知错误'))
      }
    },
    // 上传失败回调
    handleUploadError(err, file, fileList) {
      this.$message.error('上传失败，请重试')
    },
    // 查看文件
    viewFile(url) {
      window.open(url, '_blank')
    },
    // 提交表单
    handleSubmit() {
      this.$refs.agreementForm.validate(async (valid) => {
        if (!valid) return
        
        // 验证时间
        if (this.form.effectiveTime && this.form.expireTime) {
          if (this.form.effectiveTime > this.form.expireTime) {
            this.$message.error('失效时间必须在生效时间之后')
            return
          }
        }
        
        // 验证文件是否已上传
        if (!this.form.agreementUrl) {
          this.$message.error('请上传协议文件')
          return
        }
        if (!this.form.policyUrl) {
          this.$message.error('请上传电子保单')
          return
        }
        
        this.submitting = true
        try {
          // 调用录入协议/保单API接口
          const params = {
            id: Number(this.userId),
            general_policy_no: this.form.policyNo,
            general_policy_effect_date: this.form.effectiveTime ? Math.floor(this.form.effectiveTime / 1000) : '',
            general_policy_expire_date: this.form.expireTime ? Math.floor(this.form.expireTime / 1000) : '',
            agreement_url: this.form.agreementUrl,
            general_policy_url: this.form.policyUrl,
            note: this.form.note
          }
          
          const res = await saveHyxUserPolicy(params)
          if (res.err_code === 0) {
            this.$message.success('保存成功')
            this.$emit('success')
            this.handleClose()
          } else {
            this.$message.error('保存失败: ' + res.err_msg)
          }
        } catch (error) {
          console.error('保存失败:', error)
          this.$message.error('保存失败: ' + error.message)
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>